import { KeycloakEventTypeLegacy, KeycloakService } from '@inoventoryapps/keycloak-angular';
import { environment } from '../../environments/environment';

async function importKeyPair(publicKeyBase64: string, privateKeyBase64: string) {
    const base64ToBytes = (b64: string) => Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));

    const publicKeyBytes = base64ToBytes(publicKeyBase64);
    const privateKeyBytes = base64ToBytes(privateKeyBase64);

    // PUBLIC KEY = SPKI (SubjectPublicKeyInfo)
    const publicKey = await crypto.subtle.importKey(
        'spki',
        publicKeyBytes.buffer,
        { name: 'ECDSA', namedCurve: 'P-256' },
        true,
        ['verify']
    );

    // PRIVATE KEY = PKCS8
    const privateKey = await crypto.subtle.importKey(
        'pkcs8',
        privateKeyBytes,
        { name: 'ECDSA', namedCurve: 'P-256' },
        true,
        ['sign']
    );

    return { publicKey, privateKey };
}

export function initializeKeycloak(keycloak: KeycloakService) {
    return async () => {
        try {
            let mobileTokens:
                | {
                      token: string;
                      refreshToken: string;
                      idToken: string;
                      sigKeyPair: {
                          publicKey: CryptoKey;
                          privateKey: CryptoKey;
                      };
                  }
                | undefined;
            let mobileClientId = '';
            // 👇 Check if URL contains mobile/marketplace
            if (window.Callback) {
                const mobileTokenResponse = window.Callback.getLoggedInUser();
                console.log('\n\n mobileTokenResponse :>> ', mobileTokenResponse, '\n\n');
                // 🔥 This will be used to inject tokens into Keycloak init
                const { access_token, refresh_token, id_token, client_id, publicKeyBase64, privateKeyBase64 } =
                    JSON.parse(mobileTokenResponse); // Android's window.Callback
                const { publicKey, privateKey } = await importKeyPair(publicKeyBase64, privateKeyBase64);
                mobileTokens = {
                    token: access_token,
                    refreshToken: refresh_token,
                    idToken: id_token,
                    sigKeyPair: { publicKey, privateKey }
                };
                mobileClientId = client_id;
            }

            await keycloak.init({
                config: {
                    url: environment.keycloak.issuer,
                    realm: environment.keycloak.realm,

                    // If mobile marketplace, use clientId from mobile
                    clientId: mobileClientId || environment.keycloak.clientId
                },
                loadUserProfileAtStartUp: false,
                initOptions: {
                    onLoad: 'check-sso',
                    silentCheckSsoRedirectUri: `${window.location.origin}/assets/verify-sso.html`,
                    flow: 'standard',
                    pkceMethod: 'S256',
                    checkLoginIframe: false,
                    scope: 'openid profile email phone',
                    dpopEnabled: true,
                    encryptionEnabled: environment.enableEncryption,
                    enableLogging: !environment.production,
                    // Inject mobile tokens ONLY if URL condition matched
                    ...mobileTokens
                },
                enableBearerInterceptor: true,
                bearerPrefix: 'DPoP',
                bearerExcludedUrls: ['/assets', '/public', '/cdn.lokos.in', '/signer']
            });

            console.log('\n\n Keycloak Initialized \n\n');

            keycloak.keycloakEvents$.subscribe((event) => {
                if (event && event.type === KeycloakEventTypeLegacy.OnTokenExpired) {
                    keycloak
                        .updateToken(30)
                        .then((refreshed) => {
                            console.log(refreshed ? 'Token refreshed successfully' : 'Token refresh failed');
                        })
                        .catch((error) => {
                            console.error('Error during token refresh:', error);
                        });
                }
            });

            return keycloak;
        } catch (error) {
            console.error('Keycloak initialization failed:', error);
            throw error;
        }
    };
}
